export type CalendarInviteIssueSource = {
  messageId: number;
};

export function calendarInviteIssueEmailMessageIds(
  issues: ReadonlyArray<CalendarInviteIssueSource>,
): number[] {
  const seen = new Set<number>();
  const ids: number[] = [];
  for (const issue of issues) {
    const messageId = Number(issue.messageId);
    if (!Number.isInteger(messageId) || messageId <= 0 || seen.has(messageId)) continue;
    seen.add(messageId);
    ids.push(messageId);
  }
  return ids;
}

export function calendarInviteIssueTerminalContext(
  issues: ReadonlyArray<CalendarInviteIssueSource>,
) {
  const emailMessageIds = calendarInviteIssueEmailMessageIds(issues);
  return {
    terminalType: 'calendar' as const,
    surface: 'calendar' as const,
    entityType: 'calendar',
    route: '/calendar',
    title: 'Inviti calendario da riconciliare',
    ...(emailMessageIds.length > 0 ? { relations: { emailMessageIds } } : {}),
  };
}
